<template>
  <!-- 打印 -->
  <div>
    <el-dialog
      :title="$t('functionBtn.print')"
      :visible.sync="dialogVisible"
      width="800px"
      class="splitDialog"
      @close="close"
    >
      <upload
        ref="upload"
        :printShow="true"
        :tableData="tableData || []"
        @uploadPrint="uploadPrint"
      />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button  size="medium" type="primary" @click="close"  class="fixed-bottom-btn">确认</el-button> -->
        <el-button size="medium" type="primary" @click="close" class="fixed-bottom-btn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <Print ref="easyPrint">
      <print-demo :content="content"></print-demo>
    </Print>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/transportDeliveryOrder';
  import upload from '@/components/upload';
  import printDemo from '@/components/Print/printDemo';
  import Print from '@/components/Print';
  import { mapState } from 'vuex';

  export default {
    props: {
      codeNumber: {
        type: String,
        default: '',
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      formData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      upload,
      printDemo,
      Print,
    },
    data() {
      return {
        dialogVisible: false,
        content: '',
        templateCode: '',
        outboundNo: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      // 打开
      openDialog(val, outboundNo) {
        this.templateCode = val == '1' ? 'outboundPrintOne' : 'outboundPrintTwo';
        this.outboundNo = outboundNo;
        this.dialogVisible = true;
        setTimeout(() => {
          if (this.tableData.length > 0) {
            this.$refs.upload.setRadioRow(this.tableData[0]);
          }
        }, 500);
      },
      //打印或下载
      uploadPrint(val, type) {
        const params = {
          dataNo: this.codeNumber,
          downloadOrPrint: type == 1 ? 'print' : 'download',
          templateUrl: val.attachmentKey,
          templateCode: this.templateCode,
          headCompanyName: this.formData.companyName,
        };
        this.$axios
          .post(API.EXPORT_PRINT, params)
          .then((res) => {
            if (res.data.code === 0) {
              if (type == 1) {
                if (res.data.data.pdf) {
                  // window.location.href = res.data.data.pdf;
                  window.open(res.data.data.pdf, '_blank');
                } else if (res.data.data.excel) {
                  this.content = res.data.data.excel || '';
                  setTimeout(() => {
                    this.$refs.easyPrint.print();
                  }, 500);
                }
              } else {
                window.location.href = res.data.data.word;
              }
            } else {
              this.$alert(res.data.msg);
            }
          })
          .finally(() => {
            this.getHistoryPageList();
          });
      },
      getHistoryPageList() {
        let params = {
          dataType: 'DISTRIBUTION_OUTBOUND',
          dataNo: this.outboundNo,
          attachmentCategory: '1',
        };
        this.$axios.post(API.HISTORY_LIST_ATTACHMENT_PAGE, params).then((res) => {
          this.$emit('getHistoryPageList', res);
        });
      },
      showTip(tip) {
        this.$message({
          showClose: true,
          message: tip,
          type: 'error',
        });
      },
      // 弹窗关闭
      close() {
        this.$refs.upload.multipleSelection = [];
        this.dialogVisible = false;
      },
    },
  };
</script>
